import React, { FC } from 'react';

export interface FilterTagProps {
  id: string;
  name: string;
  icon: string;
  isActive: boolean;
  onClick: (id: string) => void;
}

const FilterTag: FC<FilterTagProps> = ({ id, name, icon, isActive, onClick }) => {
  return (
    <button
      type="button"
      className={`p-filter__tag ${isActive ? 'p-filter__tag--active' : ''}`}
      onClick={() => onClick(id)}
    >
      {icon && icon !== '' && (
        <picture className="p-filter__picture">
          <img loading="lazy" className="p-filter__image" src={icon} alt={name} />
        </picture>
      )}
      {name}
    </button>
  );
};

export default FilterTag;
